export enum EVENT {
  CLOSE = 'close',
  UPDATE_VALUES = 'updateValues',
  OPEN_MODAL = 'openModal'
}
